module.exports = __webpack_public_path__ + "static/media/ninx6.c0222750.jpg";